module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "cursor": "move"
    },
    attrs: {
      "id": "main_slider"
    }
  }, [_c('div', {
    staticClass: "swiper-container main_slider"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.widget.images), function(s) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('a', {
      attrs: {
        "href": s.split('?url=')[1],
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": s,
        "alt": "fashion show",
        "width": "100%"
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c67ce8c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/page/widgets/ImageSliderWidget.vue
// module id = 105
// module chunks = 0 1 2